import { FC } from 'react';
import { useFragment } from 'react-relay';
import { useFormikContext } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import TextField from 'components/TextField';
import LegacyEditor from 'components/LegacyEditor';
import CountrySelect from 'components/CountrySelect';
import RegionSelect from 'components/RegionSelect';
import CitySelect from 'components/CitySelect';
import PoiSelect from 'components/PoiSelect';

import { FormFields } from 'components/WhatToSeeEditMain';
import { WhatToSeeEditMainFields_data$key } from '__generated__/WhatToSeeEditMainFields_data.graphql';

type Props = {
  data: WhatToSeeEditMainFields_data$key;
};

const WhatToSeeEditMainFields: FC<Props> = props => {
  const data = useFragment(
    graphql`
      fragment WhatToSeeEditMainFields_data on Query {
        ...CountrySelect_data
        ...RegionSelect_data
        ...CitySelect_data
        ...PoiSelect_data
      }
    `,
    props.data
  );

  const { values } = useFormikContext<FormFields>();

  return (
    <Stack spacing={4}>
      <TextField fullWidth name="name" label="Pavadinimas" />
      <CountrySelect name="country" data={data} label="Šalis" />

      {values.country && (
        <RegionSelect
          name="region"
          data={data}
          label="Regionas"
          countryId={values.country.id}
        />
      )}

      {values.region && (
        <CitySelect
          hideCountryName
          name="city"
          data={data}
          label="Miestas"
          regionId={values.region.id}
        />
      )}

      <LegacyEditor name="description" label="Aprašymas" />
      <PoiSelect name="pois" label="Lankytinos vieto" data={data} />

      <LegacyEditor
        name="poisDescription"
        label="Lankytinų vietų intro tekstas"
      />
    </Stack>
  );
};

export default WhatToSeeEditMainFields;
